import React, { useRef } from 'react'
import useComponentSize from '@rehooks/component-size'

import Box from '../Box'

export default function SideNav({ children, ...props }) {
  const contentRef = useRef(null)
  const containerRef = useRef()

  const { width } = useComponentSize(contentRef)

  return (
    <Box
      ref={containerRef}
      overflowX="hidden"
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      width={width}
      {...props}
    >
      <Box display="flex" flex="0" flexDirection="column" ref={contentRef}>
        {children}
      </Box>
    </Box>
  )
}
